<template>
    <section class="container">
      <div class="route">
        {{$locales.ordenesgestionpagos.ordenesgestionpagos}} > {{$locales.ordenesgestionpagos.consultaordenesgestionpagos}}
      </div>
      <div class="wide-window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.ordenesgestionpagos.consultaordenesgestionpagos}}</h1>
          <div class="form-group">
            <form class="window-form" @submit.prevent="aceptar">
              <div class="row2">
                <div class="elemento">
                  <label for="fechaDesde">Fecha vencimiento</label>
                  <div class="compositeComponent">
                  <!-- Input -->
                  <md-datepicker :class = "(submitted && $v.model.fechaDesde.$invalid)?'invalid':''" id="fechaDesde" name="fechaDesde" v-model="model.fechaDesde" md-immediately><label class="insideLabel">Desde</label></md-datepicker>
                  <md-datepicker :class = "(submitted && $v.model.fechaHasta.$invalid)?'invalid lastElement':''" id="fechaHasta" name="fechaHasta" v-model="model.fechaHasta" md-immediately><label class="insideLabel">Hasta</label></md-datepicker>
                  <!-- Posibles errores de validacion -->
                  <div class="error" v-if="submitted && $v.model.fechaDesde.$invalid">La fecha inicial no puede ser posterior a la fecha final</div>
                  </div>
                </div>
                <div class="elemento">
                    <!-- COMBO -->
                  <label for="estado">Estado de la orden</label>
                  <md-field id="anchoCombo">
                    <md-select class="combo" v-model="model.estado" name="estado" id="estado" placeholder="Seleccione una opción">
                      <md-option value="1">Activa</md-option>
                      <md-option value="2">Denegada</md-option>
                      <md-option value="3">Finalizada</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              
              <div class="row2">
                <div class="elemento">
                  <!-- Cabecera -->
                  <label for="importeDesde">Importe</label>
                  <div class="compositeComponent">
                    <!-- Input -->
                    <div :class = "(submitted && $v.model.importeDesde.$invalid)?'importe inputInvalid ':'importe inputComponent'">
                      <input  type="number" id="importeDesde" step="any" name="importeDesde" autocomplete="off" placeholder="Desde" v-model="model.importeDesde"/>
                      <span class="icon">€  </span>
                    </div>
                    <!-- Input -->
                    <div :class = "(submitted && $v.model.importeHasta.$invalid)?'importe inputInvalid  lastElement':'importe inputComponent lastElement'">
                      <input type="number" id="importeHasta" step="any" name="importeHasta" autocomplete="off" placeholder="Hasta" v-model="model.importeHasta"/>
                      <span class="icon">€  </span>
                    </div>
                    <!-- Posibles errores de validacion -->
                    <div class="error" v-if="submitted && !$v.model.importeDesde.lessThanToAmount">El importe mínimo no puede ser mayor al importe máximo</div>
                    <div class="error" v-if="submitted && (!$v.model.importeDesde.maxLength || !$v.model.importeHasta.maxLength)">El campo debe tener como máximo 12 cifras</div>
                  </div>
                </div>
                <div class="elemento">
                    <!-- Cabecera -->
                  <label for="concepto">Concepto orden</label>
                  <!-- Input -->
                  <input class = "inputComponent" type="text" id="concepto" name="concepto" autocomplete="off" v-model="model.concepto"/>
                </div>
              </div>

              <div class="row2">
                <div class="elemento">
                  <label for="fechaAlta">Fecha alta</label>
                  <div class="compositeComponent">
                  <!-- Input -->
                  <md-datepicker :class = "(submitted && $v.model.fechaAltaDesde.$invalid)?'invalid':''" id="fechaAltaDese" name="fechaAltaDesde" v-model="model.fechaAltaDesde" md-immediately><label class="insideLabel">Desde</label></md-datepicker>
                  <md-datepicker :class = "(submitted && $v.model.fechaAltaHasta.$invalid)?'invalid lastElement':''" id="fechaAltaHasta" name="fechaAltaHasta" v-model="model.fechaAltaHasta" md-immediately><label class="insideLabel">Hasta</label></md-datepicker>
                  <!-- Posibles errores de validacion -->
                  <div class="error" v-if="submitted && $v.model.fechaAltaDesde.$invalid">La fecha inicial no puede ser posterior a la fecha final</div>
                  </div>
                </div>
                <div class="elemento">
                    <!-- COMBO -->
                  <label for="deudor">Deudor</label>
                  <md-field id="anchoCombo">
                    <md-select :class = "(submitted && $v.model.deudor.$invalid)?'combo inputInvalid':'combo'" name="deudor" v-model="model.deudor" id="deudor" placeholder="Seleccione un deudor">
                      <md-option v-for="pers in deudores" v-bind:key="pers.contractId"  :value="pers.contractId">{{pers.name}} - {{pers.contractId}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              
              <!-- Boton aceptar -->
              <input class="btnPrimary" type="submit" value="Aceptar" >
            </form>
            <div class="output" v-if="submitted && datosSalida">
              <md-table v-model="ordenes" @md-selected="onSelectOrdenes" class="tablaSeleccionable" md-fixed-header>
                <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                  <md-table-cell md-label="Orden" md-sort-by="id">{{ item.formats[0].value }}</md-table-cell>
                  <md-table-cell md-label="Concepto" md-sort-by="email">{{ item.concept }}</md-table-cell>
                  <md-table-cell md-label="Importe" md-sort-by="gender"><span class="importeLista">{{ item.paymentAmount.amount }} {{ item.paymentAmount.currency.id }}</span></md-table-cell>
                  <md-table-cell md-label="Fecha alta" md-sort-by="title" class="fechaLista">{{ item.creationDate }}</md-table-cell>
                  <md-table-cell md-label="Fecha vcto." md-sort-by="title" class="fechaLista">{{ item.expirationDate }}</md-table-cell>
                  <md-table-cell md-label="Pago prov." md-sort-by="gender" class="fechaLista">{{ item.paymentDate }}</md-table-cell>
                  <md-table-cell md-label="Estado" md-sort-by="title" class="descripcionLista">{{ item.status.name }}</md-table-cell>
                  <md-table-cell md-label="Nombre Deudor" md-sort-by="title" class="descripcionLista">{{ item.debtorName }}</md-table-cell>
                  <md-table-cell md-label="NIF Deudor" md-sort-by="title" class="descripcionLista">{{ item.debtorId }}</md-table-cell>
                  <md-table-cell md-label="Num Cuenta Prov." md-sort-by="title" class="descripcionLista">{{ item.supplierAccount }}</md-table-cell>
                  <md-table-cell md-label="Finan. Auto." md-sort-by="title" class="descripcionLista">{{ item.autofinancing }}</md-table-cell>
                  <md-table-cell md-label="Gastos Deudor" md-sort-by="title" class="descripcionLista">{{ item.debtorExpenses }}</md-table-cell>
                  <md-table-cell md-label="Factura IVA" md-sort-by="title" class="descripcionLista">{{ item.invoiceIva }}</md-table-cell>
                  <md-table-cell md-label="Datos retro" md-sort-by="title" v-if="false">{{ item.operationId }}</md-table-cell>
                  <md-table-cell md-label="Ind. transf." md-sort-by="title" v-if="false">{{ item.send }}</md-table-cell>
                  <md-table-cell md-label="Comisión" md-sort-by="gender" v-if="false"><span v-if="item.commission" class="importeLista">{{ item.commission.amount }} {{ item.commission.currency.code }}</span></md-table-cell>
                  <md-table-cell md-label="Importe IVA" md-sort-by="gender" v-if="false"><span v-if="item.fees" class="importeLista">{{ item.fees.amount }} {{ item.fees.currency.code }}</span></md-table-cell>
                  <md-table-cell md-label="Tipo interés" md-sort-by="title" v-if="false">{{ item.interestRate }}</md-table-cell>
                </md-table-row>
              </md-table>
              <div class="rowExcel">
                <!-- Boton aceptar -->
                <input type="submit" class="btnPrimary separacion" @click="obtenerNumOperacion" value="Retroceder" :disabled="!(anticipada && selected)" v-if=beforeSubmit>
                <input type="submit" class="btnSecondary" @click="detalleTransferencia" value="Transferencia" :disabled="!(anticipada && selected)" v-if=beforeSubmit>
                <div @click="exportExcel" class="downloadExcel">
                  <!--<img id="adPayMarkImg" src="../assets/img/pdf-icon.png" alt="Descarga pdf"> -->
                  <a id="excelIcon">Ñ</a>
                  <a id="textExcelIcon">Descargar Excel</a>
                </div>
              </div>
            </div>
            <div class="firmaconSalida" v-if=datosFirma>
              <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
            </div>
          </div>
      </div>
    </section>
</template>

<script>
import { maxLength } from "vuelidate/lib/validators";
import QueryOrdersPaymentsManagement from '../models/QueryOrdersPaymentsManagement';
import SignatureComponent from './SignatureComponent';
import { format } from 'date-fns';
import XLSX from 'xlsx/xlsx';
export default {
    name : 'QueryOrdersPaymentsManagementComponent',
    props: {
        columns: {
            type: Array,
            default: () => [
              {
                label: "Orden",
                field: "formats[0].value",
              },
              {
                label: "Concepto",
                field: "concept",
              },
              {
                label: "Importe",
                field: "amount.amount",
              },
              {
                label: "Fecha alta",
                field: "creationDate",
              },
              {
                label: "Fecha vcto.",
                field: "expirationDate",
              },
              {
                label: "Pago prov.",
                field: "paymentDate",
              },
              {
                label: "Estado",
                field: "status.name",
              },
              {
                label: "Nombre Deudor",
                field: "debtorName",
              },
              {
                label: "NIF Deudor",
                field: "debtorId",
              },
              {
                label: "Num Cuenta Prov.",
                field: "supplierAccount",
              },
              {
                label: "Finan. Auto.",
                field: "autofinancing",
              },
              {
                label: "Gastos Deudor",
                field: "debtorExpenses",
              },
              {
                label: "Factura IVA",
                field: "invoiceIva",
              }]
        },
        fileName: {
            type: String,
            default: 'consultaOrdenesGestionPagos'
        },
        sheetName: {
            type: String,
            default: 'SheetName'
        },
        fileType: {
            type: String,
            default: 'xlsx',
            validator: (val) => ['xlsx', 'xls'].includes(val)
        }
    },
    data(){
      return{
        ordenes: new Array(),
        datosSalida: false, //indicador de que hay LISTA DE SALIDA PARA MOSTRARLA CUANDO LLAMEMOS AL SERVICE
        selected: false, //indicador de si hay orden seleccionada o no
        item: null, //item seleccionado
        submitted: false,
        deudores:null, 
        beforeSubmit: true,
        mensajeError: null,
        anticipada:false, //valor por defecto para que este deshabilitado el boton de retroceder
        confirmacion: null,
        params:null,
        llamada: null,
        datosFirma: null,
        model : new QueryOrdersPaymentsManagement() //nuestro model contiene los datos de Entrada, es como el modelCriteria de TF
      }
    },
    computed : {
      isDisabled: function() { //aqui pondremos los campos obligatorios de nuestro form
        return  !this.model.deudor;
      }
    },
    created: function(){ //llamada a /api-notifications/notifications/subscription para obtener los datos
      //consulta previa de deudores
      const baseURI = '/api-confirming/confirming/supplier/debtors';
      let loader = this.$loading.show();
      var ventana=this;
      this.$http.get(baseURI)
        .then((result) => {
          //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
          result.data.data.forEach(deudor => {
            deudor.contractId = deudor.contractId.replace(/^0+/, '');
          });
          this.deudores=result.data.data;
        })
        .catch(error => {
          var codError = error.response.data.result.errors[0].errorCode;
          var descError = error.response.data.result.errors[0].errorDescription;
          ventana.mensajeError = codError + " - " + descError;
          ventana.confirmacion = "KO";
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        })
        .then(function () {
          loader.hide();
        });
    },
    components: {
      SignatureComponent
    },
    validations : { //aqui ponemos la validacion de cada input del html
      model : {
        deudor: {
          //required, //esto lo hace obligatorio
        },
        fechaDesde: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaDesde!=null && this.model.fechaHasta!=null){
              return (this.model.fechaDesde<=this.model.fechaHasta);
            }else{
              return true;
            }
          }
        },
        fechaHasta: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaDesde!=null && this.model.fechaHasta!=null){
              return (this.model.fechaDesde<=this.model.fechaHasta);
            }else{
              return true;
            }
          }
        },
        fechaAltaDesde: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaAltaDesde!=null && this.model.fechaAltaHasta!=null){
              return (this.model.fechaAltaDesde<=this.model.fechaAltaHasta);
            }else{
              return true;
            }
          }
        },
        fechaAltaHasta: {
          lessThanToDate: function() { //validacion personalizada
            if(this.model.fechaAltaDesde!=null && this.model.fechaAltaHasta!=null){
              return (this.model.fechaAltaDesde<=this.model.fechaAltaHasta);
            }else{
              return true;
            }
          }
        },
        importeDesde: {
          lessThanToAmount: function() { //validacion personalizada
            if(this.model.importeDesde!='' && this.model.importeDesde!=null  && this.model.importeHasta!='' && this.model.importeHasta!=null){
              return (parseFloat(this.model.importeDesde)<=parseFloat(this.model.importeHasta));
            }else{
              return true;
            }
          },
          maxLength: maxLength(12)
        },
        importeHasta: {
          lessThanToAmount: function() { //validacion personalizada
            if(this.model.importeDesde!='' && this.model.importeDesde!=null  && this.model.importeHasta!='' && this.model.importeHasta!=null){
              return (parseFloat(this.model.importeDesde)<=parseFloat(this.model.importeHasta));
            }else{
              return true;
            }
          },
          maxLength: maxLength(12)
        }
      }
    },
    mounted () {
      let parametros = this.$route.params;
       if(parametros.deudor!=null || parametros.fechaDesde!=null || parametros.fechaHasta!=null
         || parametros.fechaAltaDesde!=null || parametros.fechaAltaHasta!=null || parametros.importeDesde!=null
         || parametros.importeHasta!=null || parametros.concepto!=null || parametros.estado!=null) {

          this.model.deudor = parametros.deudor;
          this.model.fechaDesde = parametros.fechaDesde;
          this.model.fechaHasta = parametros.fechaHasta;
          this.model.fechaAltaDesde = parametros.fechaAltaDesde;
          this.model.fechaAltaHasta = parametros.fechaAltaHasta;
          this.model.importeDesde = parametros.importeDesde;
          this.model.importeHasta = parametros.importeHasta;
          this.model.concepto = parametros.concepto;
          this.model.estado = parametros.estado;

          this.aceptar();
        }
    },
    methods: {
      onSelectOrdenes (item) {
        if(item!=null){
            this.selected=true; //significa que hay una orden seleccionada
            if(item.status.name=="ANTICIPADA"){ //solo se pueden retroceder aquellas ordenes que hayan sido anticipadas
              this.anticipada=true; //habilita el boton retroceder
            }else{
              this.anticipada=false;
            }
          this.item=item; //guardamos el item seleccionado
        }else{
          this.selected=false;
        }
      },
      obtenerNumOperacion(){ //la consulta general (GFCOGEST no lo devuelve y la necesitamos para retroceder, hacemos esto por falta de tiempo)
        this.confirmacion = null;
        const ventana=this;
        const baseURI = '/api-confirming/confirming/orders/'+this.item.formats[0].value;
        let loader = this.$loading.show();
        this.$http.get(baseURI)
        .then((result) => {
          this.item.operationNumber=result.data.data.operationNumber;
          this.retrocesion();
        })
        .catch(error => {
          var codError = error.response.data.result.errors[0].errorCode;
          var descError = error.response.data.result.errors[0].errorDescription;
          ventana.mensajeError = codError + " - " + descError;
          ventana.confirmacion = "KO";
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        })
        .then(function () {
          loader.hide();
        });
      },
      retrocesion(){
        const ventana=this;
        const baseURI = '/api-confirming/confirming/orders/' + this.item.formats[0].value + '/advance';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'DELETE'
        };
        this.params = {
          nope : this.item.operationNumber
        };
        var params = this.params;
        let loader = this.$loading.show();
        this.$http.delete(baseURI, {params})
        .then(() => {
          ventana.confirmacion='OK';
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.aceptar(); //refresca la consulta
        })
        .catch(error => {
          if(error.response){ 
            if(error.response.status != 200) {
              if(error.response.data.result.errors[0].errorCode == "096H") {
                ventana.datosFirma = error.response.data.result.errors[0].info;
                ventana.beforeSubmit = false;
              } else {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                ventana.mensajeError = codError + " - " + descError;
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      },
      detalleTransferencia(){
        this.$router.push({ name:'detalleTransferencia', 
          params: { 
            order: this.item.formats[0].value,
            fechaDesde : this.model.fechaDesde, 
            fechaHasta : this.model.fechaHasta, 
            fechaAltaDesde : this.model.fechaAltaDesde, 
            fechaAltaHasta : this.model.fechaAltaHasta, 
            importeDesde : this.model.importeDesde, 
            importeHasta : this.model.importeHasta,
            concepto : this.model.concepto,
            estado : this.model.estado,
            deudor : this.model.deudor
          }
        });
      },
      callBackAceptar(confirmacion, mensaje){
        if(confirmacion == 'OK') {
          this.datosFirma = null;
        }
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.mensajeError = mensaje;
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },
      callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },

      transfomarSalida(salida) {
        var salidaFormateada = new Array();
        salida.forEach(element => {
          element.formats[0].value = element.formats[0].value.replace(/^0+/, '');
          element.paymentAmount.amount = this.formatearMiles(element.paymentAmount.amount);
          element.paymentAmount.currency.id = element.paymentAmount.amount? this.formatearMoneda(element.paymentAmount.currency.id) : "";
          element.creationDate = this.transformarFecha(element.creationDate);
          element.expirationDate = this.transformarFecha(element.expirationDate);
          element.paymentDate = this.transformarFecha(element.paymentDate);
          element.operationId = element.operationId ? element.operationId.replace(/^0+/, '') : element.operationId;

          if(element.commission!=null){
            element.commission.currency.code=this.formatearMoneda(element.commission.currency.id);
          }

          if(element.fees!=null){
            element.fees.currency.code=this.formatearMoneda(element.fees.currency.id);
          }

          if(element.send==true){
            element.send = 'SI';
          } else {
            element.send = 'NO';
          }
          salidaFormateada.push(element);
        });
        this.ordenes=salidaFormateada;
      },
      transformarFecha(fecha) {
        var fechaFormateada = fecha.substring(0,10).split("-")[2] + "-" + fecha.split("-")[1] + "-" + fecha.split("-")[0];
        if(fechaFormateada.length == 10) {
          return fechaFormateada;
        } else {
          return "";
        }
        
      },
      formatearMiles(importe) {
        importe = importe.toString().split('.');
        if(importe[0].length > 3) {
          importe[0] += '';
          var x = importe[0].split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + '.' + '$2');
          }
          importe[0] = x1 + x2;
          return importe.join(',');
        } else {
          return importe.join(',');
        }
      },
      formatearMoneda(coin) {
        if(coin=="978") {
          coin = "€"
          return coin;
        }
      },
      aceptar() {
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            this.beforeSubmit = true;
            let dateFormat = 'yyyy-MM-dd';
            if(this.confirmacion!='OK') this.confirmacion = null; //si la retrocesion se ha realizado correctamente, mantenemos el mensaje de operacion realizada correctamente al refrescar
            const ventana=this;
            const baseURI = '/api-confirming/confirming/supplier/ordersPaymentManagement';
            var params = {
              'dateFrom': this.model.fechaDesde ? format(this.model.fechaDesde, dateFormat) : null,
              'dateTo': this.model.fechaHasta ? format(this.model.fechaHasta, dateFormat) : null,
              'dateContractFrom': this.model.fechaAltaDesde ? format(this.model.fechaAltaDesde, dateFormat) : null,
              'dateContractTo': this.model.fechaAltaHasta ? format(this.model.fechaAltaHasta, dateFormat) : null,
              'amountFrom': this.model.importeDesde,
              'amountTo': this.model.importeHasta,
              'status': this.model.estado,
              'concept': this.model.concepto,
              'deudorId': this.model.deudor
            };
            let loader = this.$loading.show();
            this.$http.get(baseURI, {params})
            .then((result) => {
              //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
              if(result.data && result.data.data && result.data.data.length > 0){
                this.datosSalida=true;
                this.transfomarSalida(result.data.data);
              } else {
                this.datosSalida=false;
                return Promise.reject({
                  response : {
                    data : {
                      result: {
                        errors :[
                          {
                            errorCode : '200',
                            errorDescription : 'No se encontraron datos'
                          }
                        ]
                      }
                    }
                  }
                });
              }
              
            })
            .catch(error => {
              var codError = error.response.data.result.errors[0].errorCode;
              var descError = error.response.data.result.errors[0].errorDescription;
              ventana.mensajeError = codError + " - " + descError;
              ventana.confirmacion = "KO";
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            })
            .then(function () {
              loader.hide();
            });
            
          }
      },

      exportExcel() {
        let createXLSLFormatObj = [];
        let newXlsHeader = [];
        let vm = this;
      
        vm.columns.map(column => {
            newXlsHeader.push(column.label);
        });

        createXLSLFormatObj.push(newXlsHeader);
        vm.ordenes.map(value => {
            let innerRowData = [];
            vm.columns.map(val => {
              let fieldValue = value[val.field];
              if (val.field.split('.').length > 1) {
                fieldValue = this.getNestedValue(value, val.field);
              }
              if (val.dataFormat && typeof val.dataFormat === 'function') {
                    innerRowData.push(val.dataFormat(fieldValue));
                } else {
                    innerRowData.push(fieldValue);
                }
            });
            createXLSLFormatObj.push(innerRowData);
        });

        let fileName = vm.fileName + "." + vm.fileType;

        let ws_name = vm.sheetName;

        let wb = XLSX.utils.book_new(),
            ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, fileName);
      },
      getNestedValue(object, string) {
        string = string.replace(/\[(\w+)\]/g, '.$1');
        string = string.replace(/^\./, '');
        let a = string.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
          let k = a[i];
          if (k in object) {
            object = object[k];
          } else {
            return;
          }
        }
        return object;
      }
    }
}
</script>